<div class="bg-principal text-white w-full h-auto pl-12 sm:pl-20 p-6 sm:p-8">
	<div class="max-w-screen-xl mx-auto flex flex-col md:flex-row items-center justify-between gap-10">
		<div class="md:w-1/3">
			<p class="text-2xl uppercase font-bold">{{ 'newsletter.subscribete' | translate }}</p>
			<p class="text-sm sm:text-base uppercase">
				{{ 'newsletter.sumate' | translate }} <span class="font-bold">{{ 'newsletter.descuento' | translate }} </span> {{ 'newsletter.primeraCompra' | translate }}
			</p>
		</div>
		<div class="flex justify-center flex-1">
			<div [formGroup]="form" class="relative flex-1">
				<input
					type="email"
					name="email"
					formControlName="email"
					class="bg-black rounded-full font-montserrat font-normal text-sm sm:text-base text-white h-10 px-4 w-full pr-14 md:pr-16 input-white-text focus:outline-none"
					placeholder="{{ 'newsletter.email' | translate }}"
					pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
				/>

				<div class="pl-2 text-white text-sm absolute" *ngIf="email">
					{{ 'validaciones.emailValido' | translate }}
				</div>
			</div>
			<button
				[disabled]="!email ? false : true"
				(click)="saveEmail()"
				class="h-10 border-4 border-black px-2 text-white font-medium w-32 text-lg focus:bg-principal-hover hover:bg-principal-hover bg-principal rounded-full -ml-12 z-10"
			>
				Join
			</button>
		</div>
		<!-- redes
        <div class="flex flex-row justify-center p-4 gap-14">
            <a href="https://www.facebook.com/" target="_blank" aria-label="Facebook" class="mx-1 w-9 h-9 opacity-70 hover:opacity-100 focus:opacity-100 focus:outline-none"><img src="/assets/images/facebook_bco.svg" alt="Facebook" class="m-auto"></a>
            <a href="https://www.instagram.com/" target="_blank" aria-label="Instagram" class="mx-1 w-9 h-9 opacity-70 hover:opacity-100 focus:opacity-100 focus:outline-none"><img src="/assets/images/instagram_bco.svg" alt="Instagram" class="m-auto"></a>
        </div>
        -->
	</div>
</div>
